import React from 'react'

function ContactUs(): React.JSX.Element {

  return (
    <div className="dashboard">
      <h2>Contact Information</h2>
      <p>
        This is contact us page.
      </p>
    </div>
  )
}

export default ContactUs
